import { type ISwapSequencs } from '@App/types/common'
import { type IAddFaqDto, type IFaqData } from '@App/types/faqTypes'
import { API_URL } from '@Config/config'

import instance from '../instance'

export class FaqController {
    onGetFaqData(queries: string) {
        return instance.get(`${API_URL}/faq${queries}`)
    }

    onPostFaq(dto: IAddFaqDto) {
        return instance.post(`${API_URL}/faq`, dto)
    }

    onUpdateFaqList(dto: IFaqData) {
        return instance.put(`${API_URL}/faq`, dto)
    }

    onRemoveFaqById(query: string) {
        return instance.delete(`${API_URL}/faq${query}`)
    }

    onSwapBySequence(dto: ISwapSequencs) {
        return instance.put(`${API_URL}/faq/swap`, dto)
    }
}
